import { createSlice } from '@reduxjs/toolkit';

/* 
 * 사용법
  const activeStep = useSelector((state) => state.common.activeStep);
 
  dispatch(CommonActions.setActiveStep(3))
  dispatch(CommonActions.resetActiveStep())
  dispatch(CommonActions.increaseStep())
  dispatch(CommonActions.decreaseStep())


*/

let initialState = {
  activeStep: 0, // 활성화된 스텝
};

const CommonSlice = createSlice({
  name: 'Common',
  initialState,
  reducers: {
    setActiveStep(state, action) {
      state.activeStep = action.payload;
    },
    // 0으로 초기화
    resetActiveStep(state) {
      state.activeStep = 0;
    },

    // 1 증가
    increaseStep(state) {
      state.activeStep += 1;
    },

    // 1 감소
    decreaseStep(state) {
      if (state.activeStep > 0) {
        state.activeStep -= 1;
      }
    },
  },
});

export const CommonActions = CommonSlice.actions;
export default CommonSlice.reducer;
